import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { FormsModule } from '@angular/forms';
import { RegiaoService } from './regiao.service';
import { CadastroRegiaoComponent } from './cadastro-regiao/cadastro-regiao.component';
import { ListarRegioesComponent } from './listar-regioes/listar-regioes.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ConfirmDialogModule
  ],
  declarations: [ListarRegioesComponent, CadastroRegiaoComponent],
  exports: [ListarRegioesComponent, CadastroRegiaoComponent],
  providers: [RegiaoService, ConfirmationService, CookieService]
})
export class RegiaoModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/regiao/regiao.module.ts